import { SvgIcon } from '@material-ui/core';

function CheckboxSelectedIcon() {
  return (
    <SvgIcon>
      <path d="M6 4h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zm12.258 4.612l-1.26-1.269-6.785 6.785-3.209-3.2-1.261 1.26 4.47 4.47z" />
    </SvgIcon>
  );
}

export default CheckboxSelectedIcon;
